import { useTranslation } from 'next-i18next';

export const useTranslationResponse = (key: string = '', namespace: string = 'common'): string => {
  const { t } = useTranslation(namespace);
  const translation = t(key);

  return translation;
};
